import { isArray, isString } from 'lodash'
import Auditor from './Auditor'
import Broker from './Broker'
import Company from './Company'
import Media from './Media'
import Model from './Model'

export default interface User extends Model {
    readonly fullname: string
    firstname: string
    lastname: string
    email: string
    phone: string
    role: Role

    avatar: Media

    company?: Company
    auditor?: Auditor
    broker?: Broker

    group?: Company | Auditor | Broker

    email_verified_at?: string
    suspended_at?: string

    setup_password: boolean

    twoFA: boolean
    passkey: boolean
}

export enum Role {
    ADMIN = 'admin',
    MANAGER = 'manager',
    REGULATOR = 'regulator',
    BROKER = 'broker',
    AUDITOR = 'auditor',
    USER = 'user',
}

export interface Roles {
    name: string
    value: string
}

export function hasRole(user: User | null, roles?: Role | Role[] | string | string[]) {
    if (!user || !roles) return false

    if (isArray(roles)) {
        return roles.includes(user?.role)
    } else if (isString(roles)) {
        return user?.role === roles
    }

    return false
}
